import _ from 'lodash'
import {
  ActionStore,
  ChecklistStore,
  GroupedItemVM, GroupedItemsVM,
  ImageMarkerVM, ImageMarkersVM,
  ItemVM, RuleVM,
  TemplateStore, TemplateHistoryItemStore,
  Template
} from "@cmodules/checklist/assets/data/types"
import { syncRelations } from "@cmodules/checklist/utility/templateBuilderContext-new"

let tempState: ChecklistStore

export const handleAddNewSubTemplate = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  tempState = _.cloneDeep(state)
  const template: TemplateStore = action.payload.template
  const item_id: string = action.payload.item_id
  tempState.template.global_items[item_id] = template
  return tempState
}

export const handleAddMultipleNewSubTemplate = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  tempState = _.cloneDeep(state)
  const { templates, nested_templates }: { templates: { [key: string]: TemplateStore }, nested_templates: Template[] } = action.payload
  tempState.template.global_items = {
    ...tempState.template.global_items,
    ...templates
  }
  tempState.template.nested_templates = [
    ...tempState.template.nested_templates,
    ...nested_templates
  ]
  return tempState
}

export const SubTemplateCases = {
  CLK_SUB_TEMPLATE_ADD_NEW_SUB_TEMPLATE: handleAddNewSubTemplate,
  CLK_SUB_TEMPLATE_ADD_NEW_MULTIPLE_SUB_TEMPLATE: handleAddMultipleNewSubTemplate
}

export type SubTemplateActionType = keyof typeof SubTemplateCases
export const SUB_TEMPLATE_ACTION_TYPES: { [K in SubTemplateActionType]: K } = Object.fromEntries(
  Object.keys(SubTemplateCases).map((key) => [key, key])
) as { [K in SubTemplateActionType]: K }

export type ActionHandler = typeof SubTemplateCases[SubTemplateActionType]
